export default __webpack_public_path__ + "static/media/bosse.ce22839f.png";